import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './MazeResult.cssmodule.less';
import { clickButton, updateItemIndex } from '../../actions/Modal';
import {
    pagerActionTypes,
    compStatusTypes,
    ModalTypes,
    ContentTypes,
} from '@/Constants';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';

class MazeResult extends BaseComponent {
    constructor(props) {
        super(props);
        this.setMazeResultTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleCertButtonClick = this.handleCertButtonClick.bind(this);

        this.state = {
            isError: false,
            isEnter: false,
            errorMsg: '',
        };
    }

    setMazeResultTheme(theme) {
        const themeStyle = this.getTheme(theme, ModalTypes.MAZE_RESULT);
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    handleCertButtonClick(event) {
        const { certInput = {} } = this.refs;
        const { value = '' } = certInput;
        let isError = false;
        let errorMsg = '';

        if (!value.length) {
            isError = true;
            errorMsg = '이름을 입력해주세요.';
        } else if (this.Utils.hasSpecialCharacter(value)) {
            isError = true;
            errorMsg = '이름에는 특수문자를 사용할 수 없습니다.';
        } else {
            const { clickButton } = this.props.actions;
            clickButton({
                event,
                data: value,
            });
        }

        this.setState({
            isError,
            errorMsg,
        });
    }

    makeCertView(renderBlock) {
        const { isError, isEnter, errorMsg } = this.state;

        let marginStyle, isCertStyle;
        if (renderBlock) {
            marginStyle = this.Style.certMargin;
        }
        if (isError) {
            isCertStyle = this.Style.isError;
        } else if (isEnter) {
            isCertStyle = this.Style.isEnter;
        }

        return (
            <div className={`${this.Style.certView} ${marginStyle}`}>
                <div className={this.Style.certTitle}>
                    {this.Utils.getLang('Menus.maple_cert_input_title')}
                </div>
                <div className={`${this.Style.certInputArea} ${isCertStyle}`}>
                    <input
                        type="text"
                        className={this.Style.certName}
                        maxLength={10}
                        onKeyUp={({ keyCode }) => {
                            if (keyCode === 13) {
                                this.handleCertButtonClick('cert');
                            }
                        }}
                        onChange={({ target }) => {
                            const { value = '' } = target;
                            this.setState({
                                isEnter: !!value.length,
                                isError: false,
                            });
                        }}
                        ref="certInput"
                    />
                    <div className={this.Style.certErrorMessage}>
                        {errorMsg}
                    </div>
                </div>
            </div>
        );
    }

    makeRenderView(renderBlock = []) {
        const blocks = [];

        renderBlock.forEach((type) => {
            blocks.push([
                {
                    type,
                },
            ]);
        });
        return (
            <div
                className={this.Style.renderView}
                ref={(blockWrapper) => {
                    if (blockWrapper) {
                        blockWrapper.innerHTML = '';
                        const blockRenderView = new Entry.RenderView(
                            blockWrapper,
                            'LEFT_MOST'
                        );
                        blockRenderView.changeCode(
                            new Entry.Code(blocks),
                            true
                        );
                    }
                }}
            />
        );
    }

    render() {
        const { item = {} } = this.props;
        const {
            className,
            title = '',
            image = '',
            message = '',
            isNext,
            isComplete,
            renderBlock,
        } = item;

        return (
            <div
                className={`${this.Style.MazeResult} ${this.Style[className]}`}
            >
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                />
                <div className={this.Style.contentView}>
                    <img className={this.Style.resultImage} src={image} />
                    <div className={this.Style.resultTitle}>{title}</div>
                    <div
                        className={this.Style.resultMessage}
                        dangerouslySetInnerHTML={{
                            __html: message,
                        }}
                    />
                    <div>{renderBlock && this.makeRenderView(renderBlock)}</div>
                    {isComplete && this.makeCertView(renderBlock)}
                    <div className={this.Style.buttonArea}>
                        <Button
                            className={this.Style.button}
                            text={this.Utils.getLang('Menus.replay')}
                            onClick={() => this.handleButtonClick('replay')}
                        />
                        {isNext && (
                            <Button
                                className={this.Style.button}
                                text={this.Utils.getLang(
                                    'Menus.go_to_next_level'
                                )}
                                onClick={() => this.handleButtonClick('next')}
                            />
                        )}
                        {isComplete && (
                            <Button
                                className={`${this.Style.button} ${
                                    this.Style.cert
                                }`}
                                text={this.Utils.getLang('Menus.jr_down_cert')}
                                onClick={() =>
                                    this.handleCertButtonClick('cert')
                                }
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

MazeResult.displayName = 'MazeResult';
MazeResult.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(MazeResult);



// WEBPACK FOOTER //
// ./components/ModalSet/MazeResult.js